export const NOTIFICATION_TYPE = {
  ACK: 'ack',
  FIRST: 'first',
  MID: 'mid',
  FINAL: 'final',
  SINGLE: 'single',
};
